import { parsePagingQuery, toQueryParam } from "../../../handlers/filter";
import { isDescending } from "../../../types";
import { EXTERNAL_SEGMENT_FILTER_KEYS } from "../types";
export const toQueryParams = (filters = {}, sort) => {
    const { where = [] } = filters;
    const queryParams = [];
    where.forEach(({ field, type, value }) => {
        if (!EXTERNAL_SEGMENT_FILTER_KEYS.includes(field) ||
            value == null ||
            ((Array.isArray(value) || typeof value === "string") && !value.length)) {
            return;
        }
        queryParams.push(`${field}=${toQueryParam({ field, type, value })}`);
    });
    if (filters.paging) {
        const { size, token, offset = 0 } = filters.paging;
        queryParams.push(parsePagingQuery({ size, token, offset }).replace(/^&/, ""));
    }
    if (sort?.field && sort?.direction) {
        queryParams.push(`sortBy=${sort.field} ${isDescending(sort.direction) ? "desc" : "asc"}`);
    }
    if (queryParams.length === 0) {
        return "";
    }
    return `?${queryParams.join("&")}`;
};
//# sourceMappingURL=params.js.map